<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
      <el-button-group class="YeniBtn" v-if="Kaydet">
        <el-button v-if="$store.getters.Yetki.iptal>1" type="danger" size="small" class="" @click="Islem('iptal')"
                   icon="el-icon-close">Seçilenleri İptal Et
        </el-button>
        <el-button v-if="$store.getters.Yetki.iptal>0" type="success" size="small" class="" @click="Islem('duzenle')"
                   icon="el-icon-check">Seçilenleri Düzenle
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-row :gutter="24">
        <el-col :span="19">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>

          <el-table
            v-if="tableDisplay"
            ref="multipleTable"
            class="table-xs"
            :data="tableData"
            :height="Height"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>

            <el-table-column
              prop="Bilgi"
              label="Mesken Bilgi">
            </el-table-column>
            <el-table-column
              label="İlk Endeks"
              width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.iEndeks"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="Son Endeks"
              width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sEndeks"></el-input>
              </template>
            </el-table-column>

          </el-table>

        </el-col>

        <el-col :span="5">
          <el-collapse class="Filtre" v-model="FiltreCollapse">
            <el-collapse-item :title="Sayfa.FiltreAdi" name="1">

              <el-form :rules="FormHata" :model="Form"
                       @submit.prevent.native="Getir"
                       ref="FiltreForm">

                <el-form-item label="Site / Bina" prop="Bina_id">
                  <el-select @change="SayacGetir()" v-model="Form.Bina_id" filterable>
                    <el-option
                      v-for="item in Binalar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Okumalar" prop="Sayac_id">
                  <el-select v-model="Form.Sayac_id" :disabled="SayacDisplay" filterable>
                    <el-option
                      v-for="item in SayacListe"
                      :key="item.id"
                      :label="item.Kategori"
                      :value="item.id">
                      <span style="float: left">{{ item.Kategori }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.Tarih }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button type="primary" class="btn-block" size="medium" @click="Getir()"
                           icon="el-icon-check">Endeksleri Getir
                </el-button>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import Yukleniyor from "../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: false,
        Height: window.innerHeight - 100,
        FiltreCollapse: '1',
        Yetki: false,
        Kaydet: false,
        Sayfa: {
          Adi: 'Sayaç İşlem',
          ButtonAdi: 'Uygula',
          FiltreAdi: 'Filtreleme',
        },

        Form: {
          Bina_id: null,
          Sayac_id: null,
          secilenData: []
        },
        FormHata: {
          Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Sayac_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        Binalar: [],
        SayacListe: [],
        tableData: [],
        tableDisplay: false,
        SayacDisplay: true,

      }
    },
    methods: {
      Islem(tur) {
        this.lo = true;
        this.$store.dispatch("Put", {...this.Form, path: 'iptal/sayac/' + tur})
          .then(response => {
            this.lo = false;
            if (response.Durum == "OK") {
              //console.log(response);
              this.$message.success(response.Mesaj);
              this.hata = response.Hata;
              this.Getir();
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
        this.Kaydet = true
      },
      handleSelectionChange(val) {
        this.Form.secilenData = val;
        this.Kaydet = true
      },
      Getir() {
        this.lo = true;
        this.$refs['FiltreForm'].validate((valid) => {
          if (valid) {
            this.$store.dispatch("Post", {...this.Form, path: 'iptal/sayac/'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.tableData = response.Data;
                  this.tableDisplay = true;
                } else {
                  this.$message.error(response.Mesaj);
                  this.tableDisplay = false;
                }
              })


          }
        })
      },
      SayacGetir() {
        this.$store.dispatch("Get", {path: 'iptal/sayac/' + this.Form.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.SayacListe = response.Liste
              this.SayacDisplay = false;
            } else {
              this.$message.error(response.Mesaj);
              this.SayacListe = [];
              this.SayacDisplay = true;
              this.hata = response.Hata;
            }
          });
      },
      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'yonetim/bina'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      },
    },
    created() {
      this.SayfaYukle();
      this.Yetki = this.$store.getters.Yetki.iptal == 2 ? true : false;
      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
        this.SayacGetir();
      }
    },
    computed: {
      Secilen() {
        return this.Form.secilenData
      }
    },
    watch: {
      Secilen() {
        if (this.Form.secilenData[0]) this.Kaydet = true; else this.Kaydet = false;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Iptal/sayac.vue